// src/app/_services/theme.service.ts
import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

export type ThemeMode = 'light' | 'dark' | 'system';
type EffectiveTheme = 'light' | 'dark';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private renderer: Renderer2;
  private currentTheme: ThemeMode = 'system';
  private media = window.matchMedia('(prefers-color-scheme: dark)');
  private onMediaChange = () => this.applyTheme(this.currentTheme);

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  applyTheme(theme: ThemeMode): void {
    this.media.removeEventListener('change', this.onMediaChange);

    const effective: EffectiveTheme = theme === 'system'
      ? (this.media.matches ? 'dark' : 'light')
      : theme;

    const html = document.documentElement;
    this.renderer.removeClass(html, 'light-theme');
    this.renderer.removeClass(html, 'dark-theme');
    this.renderer.addClass(html, `${effective}-theme`);
    this.renderer.setAttribute(html, 'data-bs-theme', effective);

    if (theme === 'system') {
      this.media.addEventListener('change', this.onMediaChange);
    }

    this.currentTheme = theme;
    localStorage.setItem('theme', theme);
  }

  loadSavedTheme(): void {
    const saved = (localStorage.getItem('theme') as ThemeMode) || 'system';
    this.applyTheme(saved);
  }

  get theme(): ThemeMode {
    return this.currentTheme;
  }

  toggleTheme(): void {
    if (this.currentTheme === 'light') this.applyTheme('dark');
    else if (this.currentTheme === 'dark') this.applyTheme('system');
    else this.applyTheme('light');
  }
}
